<template>
  <div class="modal">
    <div class="modal__bg" @click="$emit('close')"></div>
    <div ref="modalBody" class="modal__body">
      <div v-if="modalParams.name === 'add-tenant'">
        <h4 class="modal__header">
          <span>Add New Tenant</span>
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <AddNewTenant
          :single-record="modalParams.singleRecord"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'edit-tenant'">
        <h4 class="modal__header">
          <span>
            Edit Tenant Details
          </span>
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <EditTenant
          :tenant="modalParams.singleRecord"
          :activeIndex="modalParams.activeIndex"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'tenant-add-user'">
        <h4 class="modal__header">
          {{ modalParams.singleRecord.name }} - Add Account
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <AddTenantUser
          :tenant="modalParams.singleRecord"
          :roles="modalParams.roles"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'tenant-edit-user'">
        <h4 class="modal__header">
          {{ modalParams.tenant.name }} - Edit Account
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <EditTenantUser
          :tenant="modalParams.tenant"
          :user="modalParams.user"
          :roles="modalParams.roles"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'tenant-view-user'">
        <h4 class="modal__header">
          {{ modalParams.tenant.name }} - Accounts
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <UserListItemView
          :tenant="modalParams.tenant"
          :user="modalParams.user"
          :roles="modalParams.roles"
          @close="$emit('close')"
        />
      </div>
      <div v-if="modalParams.name === 'report-bug'">
        <h4 class="modal__header">
          Report an Issue
          <img
            src="~@/assets/media/icons/close.svg"
            alt="close icon"
            @click="$emit('close')"
          />
        </h4>
        <ReportABug @close="$emit('close')" />
      </div>
      <ProfileEdit v-if="modalParams.name === 'edit'" @close="$emit('close')" />
    </div>
  </div>
</template>

<script>
import { ReportABug } from "@/modules/concierge/elements/forms";

import {
  AddNewTenant,
  AddTenantUser,
  EditTenant,
  EditTenantUser
} from "@/modules/superadmin/elements/forms";
import UserListItemView from "./UserListItemView";
import ProfileEdit from "@/modules/admin/elements/ProfileEdit";

export default {
  name: "Modal",
  components: {
    AddNewTenant,
    AddTenantUser,
    EditTenant,
    EditTenantUser,
    UserListItemView,
    ProfileEdit,
    ReportABug
  },
  props: {
    backTo: String,
    isOpened: {
      type: Boolean,
      default: false
    },
    modalParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  destroyed() {
    document.body.style.overflow = "initial";
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  created() {},
  methods: {
    close() {},
    handleToggleScroll(params) {
      const { scroll } = params;
      this.$refs.modalBody.style.overflow = scroll ? "auto" : "hidden";
    }
  }
};
</script>

<style lang="scss" scoped>
.h-0 {
  height: 0;
}
.modal {
  display: block;
  min-height: 100vh;
  left: 0;
  width: 100%;
  .row {
    width: inherit;
  }
  /deep/ &__bg {
    background-color: black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  /deep/ &__body {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    font-family: "Gotham";
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 650px;
    z-index: 1;
    .form-material {
      padding-top: 10px;
    }
    a {
      font-family: "Gotham";
      font-size: $font-size-sm;
    }
    button {
      padding: 8px 14px;
      font-size: $font-size-sm;
    }
  }
  /deep/ &__header {
    color: $gray-900;
    font-size: $font-size-base;
    margin-bottom: 40px;
    position: relative;
    img {
      cursor: pointer;
      top: 0;
      position: absolute;
      right: 0;
    }
    span {
      font-family: "Gotham";
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
